@if (!isLoading) {
  <oui-autocomplete
    label="Nature"
    [options]="natureAutocompleteOptions"
    [control]="natureControl"
    [allowCustomValue]="true"
    class="width-100pc"
  [displayResetButton]="true"></oui-autocomplete>
}
